'use client'

import { Globe, X } from 'lucide-react'
import { getTagColor } from './tagUtils'

interface TagPillProps {
  name: string
  isGlobal?: boolean
  readonly?: boolean
  onRemove?: () => void
  onClick?: () => void
}

export function TagPill({
  name,
  isGlobal = false,
  readonly = false,
  onRemove,
  onClick,
}: TagPillProps) {
  const backgroundColor = getTagColor(name)

  return (
    <span
      className="group relative inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium text-white transition-all hover:px-1.5"
      style={{ backgroundColor }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      title={isGlobal ? `${name} (Global tag)` : name}
    >
      {isGlobal && <Globe size={10} className="opacity-80" />}
      {name}
      {!readonly && onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
          className="opacity-0 transition-opacity group-hover:opacity-100"
          aria-label={`Remove ${name} tag`}
        >
          <X size={12} />
        </button>
      )}
    </span>
  )
}
